import { render, staticRenderFns } from "./QuotationPrint.vue?vue&type=template&id=22724fd0&scoped=true&"
import script from "./QuotationPrint.vue?vue&type=script&lang=js&"
export * from "./QuotationPrint.vue?vue&type=script&lang=js&"
import style0 from "lity/dist/lity.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./QuotationPrint.vue?vue&type=style&index=1&id=22724fd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22724fd0",
  null
  
)

export default component.exports